import React from "react";
import { Modal} from "antd";
import { URL_TANK } from "../../constants/urls";
import ErrorMessages from "../../common/ErrorMessages";
import ColorButton from "../../common/ColorButton";
import TSTable from "../../common/TSTable";
import { dateTimeToHumanString } from "../../frameworks/Util";
import _ from "lodash";

export default function PurchaseCTTStockLogModal(props) {
  const { open, onClose, target} = props;
  const [ errorMessage, setErrorMessage ] = React.useState();
  const tableRef = React.useRef();
  const columns = [
    {
      title: 'วัน - เวลา',
      dataIndex: 'created',
      key: 'created',
      render : (value) => dateTimeToHumanString(value),
    },
    {
      title: 'หมายเหตุ',
      dataIndex: 'note',
      key: 'note',
    },
    {
      title: 'น้ำหนักคงเหลือ',
      dataIndex: 'weight',
      key: 'weight',      
    },
    {
      title: 'ผู้บันทึก',
      dataIndex: 'created_by_name',
      key: 'created_by_name',      
    },
  ]

  const refreshData = async() => {
    if(tableRef.current)(
      await tableRef.current.fetchWithoutResetPage()
    )
  }

  React.useState(() => {
    if(target){
      refreshData();
    }
  },[target])

  React.useEffect(() => {
    setErrorMessage(null)
  },[open])

  return(
    <Modal
      title={<center>ประวัติเปลี่ยนน้ำหนัก</center>}
      open={open}
      onCancel={onClose}
      width={750}
      destroyOnClose
      footer={[
        <ColorButton onClick={onClose}>ปิด</ColorButton>
      ]}
    >
      <ErrorMessages message={errorMessage}/>
      {target && <TSTable
        ref={tableRef}
        columns={columns}
        size={'small'}
        url={URL_TANK.IMPORT_CONCENTRATE_STOCK_WEIGHT_LOG}
        params={{imported_concentrate_latex_stock : target}}
      />}
    </Modal>
  )
}